import { authAxios } from "src/libs/axios/authAxios";
import {
  IApplyCheckPromotionCodeReq,
  ICheckCouponReq,
  ICheckPromotionCodeReq,
  ICheckPromotionCodeRes,
  ICheckPromotionTrialReq,
  ICheckServiceIdReq,
  IConfirmUserReq,
  ICreateServiceBillReq,
  ICreateServicePromotionAskReq,
  ICreateServicePromotionAskV2Req,
  ICreateServicePromotionBillReq,
  ICreateServiceSiteReq,
  ICreateServiceTrialReq,
  IGetBillHistoryReq,
  IGetBillHistoryRes,
  IGetBillHistoryUidReq,
  IGetCashUserStatusReq,
  IGetCashUserStatusRes,
  IGetCountryCodeReq,
  IGetCountryCodeRes,
  IGetCreatePrice,
  IGetCreditHistoryReq,
  IGetCreditHistoryRes,
  IGetInicisDataNewReq,
  IGetInicisDataReq,
  IGetInicisDataRes,
  IGetMyServiceBillReq,
  IGetNxacInfoReq,
  IGetPriceListReq,
  IGetPriceListRes,
  IGetServiceNxacListReq,
  IGetServiceUnregisterBillReq,
  IGetServiceUnregisterBillRes,
  IGetTotalCreditReq,
  IGetTotalCreditRes,
  IGetUnregisterBillReq,
  IGetUnregisterBillRes,
  IPayPalReturnUrlRes,
  IPromotionGetInicisDataRes,
  IRequestCashReq,
  IRestartSubscriptionReq,
  ISaveInicisBillReq,
  ISavePromotionInicisBillReq,
  ISendPaypalSendSuccessMailReq,
  ISendPaypalSendSuccessMailRes,
  ISetServiceNxacListReq,
  ISubscriptionActiveReq,
  ISubscriptionSuspendReq,
  IUpdateCashStatus,
  IUpdateCompanyName,
  IUpdateServiceNameReq,
  TotalNxacType,
} from "./types/pay.type";
import { CouponCodeInfo } from "./types/common.type";

// GET
export const applyCheckPromotionCode = async ({
  product,
}: IApplyCheckPromotionCodeReq) => {
  const response = await authAxios.get(
    `/wapi/cloud/pay/promotion/applyCheck?product=${product}`
  );
  return response.data;
};

export const checkPromotionCode = async ({
  promotionCode,
  product,
}: ICheckPromotionCodeReq) => {
  const response = await authAxios.get(
    `/wapi/cloud/pay/promotion/${promotionCode}?product=${product}`
  );
  return response.data;
};
// 프리미엄 코드 확인 API
export const checkPromotionCodeV2 = async ({
  promotionCode,
  product,
}: ICheckPromotionCodeReq): Promise<ICheckPromotionCodeRes> => {
  const response = await authAxios.get(
    `/wapi/cloud/pay/promotion/${promotionCode}/v2?product=${product}`
  );
  return response.data;
};

export const checkPromotionTrial = async ({
  product,
}: ICheckPromotionTrialReq): Promise<any> => {
  const response = await authAxios.get(
    `/wapi/cloud/pay/promotion/check/trial?product=${product}`
  );
  return response.data;
};

export const getUnregisterBill = async ({
  billType,
  product,
}: IGetUnregisterBillReq): Promise<IGetUnregisterBillRes[]> => {
  const response = await authAxios.get(
    `/wapi/cloud/pay/service/bill/unregister/${billType}?product=${product}`
  );
  return response.data;
};
export const getMyServiceBill = async ({
  product,
}: IGetMyServiceBillReq): Promise<any> => {
  const response = await authAxios.get(
    `/wapi/cloud/pay/service/bill/myList?product=${product}`
  );
  return response.data;
};
export const getBillHistory = async ({
  offset,
  limit,
  order,
  product,
}: IGetBillHistoryReq): Promise<IGetBillHistoryRes> => {
  const response = await authAxios.get(
    `/wapi/cloud/pay/bill/history?offset=${offset}&limit=${limit}&order=${order}&product=${product}`
  );
  return response.data;
};
export const getBillHistoryUid = async ({
  serviceBillHisUid,
}: IGetBillHistoryUidReq): Promise<any> => {
  const response = await authAxios.get(
    `/wapi/cloud/pay/bill/history/${serviceBillHisUid}`
  );
  return response;
};
export const getServiceNxacList = async ({
  serviceUid,
}: IGetServiceNxacListReq): Promise<any> => {
  const response = await authAxios.get(
    `/wapi/cloud/nxac/service/${serviceUid}/list`
  );
  return response;
};
export const getTotalNxacList = async (): Promise<TotalNxacType[]> => {
  const response = await authAxios.get(`/wapi/cloud/nxac/list`);
  return response.data;
};
export const getNxacInfo = async ({
  nxacAppUid,
}: IGetNxacInfoReq): Promise<any> => {
  const response = await authAxios.get(`/wapi/cloud/nxac/${nxacAppUid}`);
  return response;
};
export const getServiceUnregisterBill = async (
  req: IGetServiceUnregisterBillReq
): Promise<IGetServiceUnregisterBillRes[]> => {
  const { billType, product } = req;
  const response = await authAxios.get(
    `/wapi/cloud/pay/service/bill/unregister/${billType}?product=${product}`
  );
  return response.data;
};

// POST
// service/bill/new  ---> service/inicis/bill/new로 변경 (2025-04-17)
export const createServiceInicisBill = async (
  req: ICreateServiceBillReq
): Promise<any> => {
  const response = await authAxios.post(
    `/wapi/cloud/pay/service/inicis/bill/new`,
    req
  );
  return response;
};
export const createServiceBill = async (
  req: ICreateServiceBillReq
): Promise<any> => {
  const response = await authAxios.post(
    `/wapi/cloud/pay/service/bill/new`,
    req
  );
  return response;
};
// 프리미엄코드 전용 Bill New (구독하기 버튼)
export const createServicePremiumBill = async (
  req: ICreateServicePromotionBillReq
): Promise<any> => {
  const response = await authAxios.post(
    `/wapi/cloud/pay/promotion/bill/new`,
    req
  );
  return response;
};

// 사이트 생성
export const createServiceSite = async (
  req: ICreateServiceSiteReq
): Promise<any> => {
  const response = await authAxios.post(
    `/wapi/cloud/pay/service/site/new`,
    req
  );
  return response.data;
};
export const createServiceTrial = async (
  req: ICreateServiceTrialReq
): Promise<any> => {
  const response = await authAxios.post(
    `/wapi/cloud/pay/promotion/new/trial`,
    req
  );
  return response.data;
};
export const createServicePromotionAsk = async (
  req: ICreateServicePromotionAskReq
): Promise<any> => {
  const response = await authAxios.post(
    `/wapi/cloud/pay/promotion/new/promotion`,
    req
  );
  return response.data;
};
// 문의하기
export const createServicePromotionAskV2 = async (
  req: ICreateServicePromotionAskV2Req
): Promise<any> => {
  const response = await authAxios.post(
    `/wapi/cloud/pay/promotion/new/promotion/v2`,
    req
  );
  return response.data;
};
export const getPromotionList = async (): Promise<any> => {
  const response = await authAxios.post(`/wapi/cloud/pay/promotion/list`);
  return response;
};
export const createPromotion = async (): Promise<any> => {
  const response = await authAxios.post(`/wapi/cloud/pay/promotion/new`);
  return response;
};
export const updatePromotion = async (): Promise<any> => {
  const response = await authAxios.post(`/wapi/cloud/pay/promotion/update`);
  return response;
};
export const getPriceList = async (
  req: IGetPriceListReq
): Promise<IGetPriceListRes[]> => {
  const response = await authAxios.post(`/wapi/cloud/pay/price/list`, req);
  return response.data;
};
export const getCountryCode = async (
  req: IGetCountryCodeReq
): Promise<IGetCountryCodeRes> => {
  const response = await authAxios.post(`/wapi/cloud/pay/countryCode`, req);
  return response.data;
};
export const getCreatePrice = async (req: IGetCreatePrice): Promise<any> => {
  const response = await authAxios.post(`/wapi/cloud/pay/price/new`, req);
  return response.data;
};
export const checkServiceId = async (req: ICheckServiceIdReq): Promise<any> => {
  const response = await authAxios.post(`/wapi/cloud/service/check/url`, req);
  return response.data;
};
export const updateServiceName = async (
  req: IUpdateServiceNameReq
): Promise<any> => {
  const response = await authAxios.post(`/wapi/cloud/service/name`, req);
  return response;
};
// site/pay에서 이니시스 데이터 요청
export const getInicisData = async (
  req: IGetInicisDataReq
): Promise<IGetInicisDataRes> => {
  const response = await authAxios.post(
    `/wapi/cloud/pay/service/getInicisData`,
    req
  );
  return response.data;
};
// 프로모션용 getInicisData (프리미엄 코드 카드 결제용 이니시스 데이터 요청) - 2025-11-19 추가
export const promotionGetInicisData =
  async (): Promise<IPromotionGetInicisDataRes> => {
    // request 없음, session 유저 정보로 조회해서 반환됨
    const response = await authAxios.post(
      `/wapi/cloud/pay/promotion/getInicisData`
    );
    return response.data;
  };
// 프로모션용 inicisData 세션 저장[변경될 수도 있음] - 2025-11-19 추가 (기존 bill/new 랑 동일한 역할)
export const savePromotionInicisBill = async (
  req: ISavePromotionInicisBillReq
): Promise<any> => {
  // response 200 반환
  const response = await authAxios.post(
    `/wapi/cloud/pay/promotion/inicisData/save`,
    req
  );
  return response.data;
};

// 카드 교체용 이니시스 데이터 요청 (구독 재개시 사용)
export const getInicisDataNewCard = async (
  req: IGetInicisDataNewReq
): Promise<IGetInicisDataRes> => {
  const { serviceBillUid } = req;
  const response = await authAxios.post(
    `/wapi/cloud/pay/service/getInicisData/restart/${serviceBillUid}`
  );
  return response.data;
};
// 구독 재개하기 시 이니시스 데이터 저장
export const saveInicisBill = async (req: ISaveInicisBillReq): Promise<any> => {
  const response = await authAxios.post(
    `/wapi/cloud/pay/service/inicis/bill/save`,
    req
  );
  return response.data;
};

export const getCash = async (): Promise<any> => {
  const response = await authAxios.post(`/wapi/cloud/pay/service/cash`);
  return response;
};
// 현금결제 요청
export const requestCash = async (req: IRequestCashReq): Promise<any> => {
  const response = await authAxios.post(
    `/wapi/cloud/pay/service/cash/new`,
    req
  );
  return response.data;
};
export const getCashUserStatus = async (
  req: IGetCashUserStatusReq
): Promise<IGetCashUserStatusRes> => {
  const response = await authAxios.post(
    `/wapi/cloud/pay/service/cash/user`,
    req
  );
  return response.data;
};
export const updateCashStatus = async (
  req: IUpdateCashStatus
): Promise<any> => {
  const response = await authAxios.post(
    `/wapi/cloud/pay/service/cash/update`,
    req
  );
  return response.data;
};
// 구독 중지
export const subscriptionSuspend = async (
  req: ISubscriptionSuspendReq
): Promise<any> => {
  // rest값 타입정의 할것!
  const { product, ...rest } = req;
  const response = await authAxios.post(
    `/wapi/cloud/pay/service/subscriptions/suspend/${product}`,
    { SUSPEND: "" }
  );
  return response.data;
};
// 재구독
export const subscriptionActive = async (
  req: ISubscriptionActiveReq
): Promise<any> => {
  // rest값 타입정의 할것!
  const { product, orderId } = req;
  const response = await authAxios.post(
    `/wapi/cloud/pay/service/subscriptions/activate/${product}`,
    orderId
  );
  return response;
};
// 구독 재개 (billType === PAY && payStatus === ENDING 상태일때 구독 재개)
// 기존 등록된 카드로 바로 결제
export const restartSubscription = async (
  req: IRestartSubscriptionReq
): Promise<any> => {
  // rest값 타입정의 할것!

  const response = await authAxios.post(
    `/wapi/cloud/pay/service/subscribtions/restart`,
    req
  );
  return response;
};

// 구독 재개 (billType === PAY && payStatus === ENDING 상태일때 구독 재개)
// 카드 교체 후 바로 결제
// 1. getInicisData 호출
// 2. 재결제용 returnUrl 호출
// returnUrl = /service/returnUrl/restart/{oid}/{product}/{serviceBillUid}
export const resumeSubscription = async (
  req: ISubscriptionActiveReq
): Promise<any> => {
  // rest값 타입정의 할것!
  const { product, orderId } = req;
  const response = await authAxios.post(
    `/wapi/cloud/pay/service/subscriptions/activate/${product}`,
    orderId
  );
  return response;
};

export const confirmUser = async (req: IConfirmUserReq): Promise<any> => {
  const response = await authAxios.post(`/wapi/cloud/pay/service/confirm`, req);
  return response.data;
};
export const setServiceNxacList = async (
  req: ISetServiceNxacListReq
): Promise<any> => {
  // rest값 타입정의 할것!
  const { serviceUid, ...rest } = req;
  const response = await authAxios.post(
    `/wapi/cloud/nxac/service/${serviceUid}/update`,
    rest
  );
  return response;
};
export const createNxac = async (): Promise<any> => {
  const response = await authAxios.post(`/wapi/cloud/nxac/create`);
  return response;
};
export const deleteNxac = async (): Promise<any> => {
  const response = await authAxios.post(`/wapi/cloud/nxac/delete`);
  return response;
};
export const updateNxac = async (): Promise<any> => {
  const response = await authAxios.post(`/wapi/cloud/nxac/update`);
  return response;
};
export const changeNxac = async (): Promise<any> => {
  const response = await authAxios.post(
    `/wapi/cloud/pay/service/changeManager`
  );
  return response;
};
export const paypalReturnUrl = async (): Promise<IPayPalReturnUrlRes> => {
  const response = await authAxios.post(`/paypal/returnUrl`);
  return response.data;
};
export const sendPaypalSuccessMail = async (
  req: ISendPaypalSendSuccessMailReq
): Promise<ISendPaypalSendSuccessMailRes> => {
  const { subscriptionId } = req;
  const response = await authAxios.post(
    `/wapi/cloud/paypal/mail/success/${subscriptionId}`
  );
  return response.data;
};

// OCI WRAPSODY 회사명 업데이트
export const updateCompanyName = async (req: IUpdateCompanyName) => {
  const response = await authAxios.post(`/wapi/cloud/user/update/company`, req);
  return response.data;
};

// 총 잔여 크레딧 조회
export const getTotalCredit = async (
  req: IGetTotalCreditReq
): Promise<IGetTotalCreditRes> => {
  const { serviceUid } = req;
  const response = await authAxios.get(
    `/wapi/cloud/pay/credit/total/${serviceUid}`
  );
  return response.data;
};

// 크레딧 이력 조회
export const getCreditHistory = async ({
  serviceUid,
  offset = 0,
  limit = 5,
}: IGetCreditHistoryReq): Promise<IGetCreditHistoryRes> => {
  const response = await authAxios.get(
    `/wapi/cloud/pay/credit/history/${serviceUid}?offset=0&limit=5&order=-cch.entry_time`
  );
  return response.data;
};
// 쿠폰 유효성 검사
export const checkCoupon = async ({
  couponCode,
  product,
}: ICheckCouponReq): Promise<CouponCodeInfo> => {
  const response = await authAxios.get(
    `/wapi/cloud/pay/coupon/check/${couponCode}?product=${product}`
  );
  return response.data;
};
